<footer class="footer bg-dark rounded-top text-center">
   <div class="container py-2">
     <p class="text-white my-2">
      &copy; {{ autor.nombre + ' ' + autor.apellido}}
     </p>
   </div>
</footer>
